import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import "../css/ManageUsers.css";

const ManageUsers = () => {
  const { getAllUsers, manageUserStatus } = useContext(AuthContext);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const data = await getAllUsers();
        setUsers(Array.isArray(data) ? data : []);
      } catch {
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, [getAllUsers]);

  const handleAction = async (id, action) => {
    if (!window.confirm(`Confirm ${action} user?`)) return;

    try {
      const res = await manageUserStatus(id, action);
      if (res.ok) {
        setUsers((prev) =>
          prev.map((u) =>
            u.id === id ? { ...u, status: res.status } : u
          )
        );
      } else {
        alert(res.error || "Action failed");
      }
    } catch {
      alert("Server error");
    }
  };

  if (loading) return <p>Loading users...</p>;

  return (
    <div className="manage-users">
      <h1>Manage Users</h1>

      {users.length === 0 ? (
        <p>No users found</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Address</th>
              <th>Email</th>
              <th>Phone number</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.username}</td>
                <td>{u.address}</td>
                <td>{u.email}</td>
                <td>{u.phone}</td>
                <td>
                  <span className={`status ${u.status}`}>
                    {u.status}
                  </span>
                </td>
                <td>
                  {u.status !== "active" && (
                    <button onClick={() => handleAction(u.id, "activate")}>
                      Activate
                    </button>
                  )}
                  {u.status === "active" && (
                    <button onClick={() => handleAction(u.id, "block")}>
                      Block
                    </button>
                  )}
                  {u.status === "blocked" && (
                    <button onClick={() => handleAction(u.id, "unblock")}>
                      Unblock
                    </button>
                  )}
                  <button onClick={() => handleAction(u.id, "pending")}>
                    Pending
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ManageUsers;
